import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { BrdsqlService } from '../../services/brdsql.service';
import { from, iif, Subscription } from 'rxjs'
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-oilpay',
  templateUrl: './oilpay.component.html',
  styleUrls: ['./oilpay.component.css']
})
export class OilpayComponent implements OnInit {

  yearid?: string = ""
  usercode?: string = ""
  groupcode?: string = ""
  oil_type?: string = ""
  car_code?: string = ""
  oillimit = [0, 0];

  today: number = Date.now();
  @ViewChild('oil_amount', { read: ElementRef }) oil_amountElement: ElementRef<HTMLInputElement>;

  constructor(
    private brdsql: BrdsqlService,
    private spinner: NgxSpinnerService,
  ) {
    this.yearid = '2526'//localStorage.getItem('yearCr')
    this.usercode = localStorage.getItem('supcode')
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  period_cane?: any[] = []
  getPeriod_cane(): void {
    this.brdsql.getPeriod_cane().subscribe({
      next: (res: any) => {
        this.period_cane = res.recordset
        // console.log('period cane ' , this.period_cane)
      },
      error: (e) => console.error(e)
    })
  }

  oil_value = 0;
  groupdata?: any = []
  sub_groupdata: Subscription
  async getdatanext(e: any) {
    this.spinner.show();
    let x = e.target.value
    if (x == '1') this.oil_value = 3;
    else if (x == '2') this.oil_value = 0.5;
    console.log('getdatanext:', x)
    this.oil_type = x
    this.sub_groupdata = await this.brdsql.getGroupSelect(x).subscribe({
      next: (res: any) => {
        let data = res;
        data.sort((a, b) => a.groupcode.localeCompare(b.groupcode));
        this.groupdata = res
        this.spinner.hide();
        // console.log('res.recordset' ,res.recordset)
      },
      error: (e) => console.error(e)
    })
  }

  selectcarcode(e: any) {
    let carSelect: any = []
    let x = e.target.value
    carSelect = this.groupdata.filter((el: { carcode: any; }) => el.carcode == x);
    // console.log('carSelect ' ,carSelect)
    this.groupcode = carSelect[0].groupcode
  }

  // ข้อมูลการเบิกน้ำมัน
  oilPeriod_cane?: string = ""
  getOilData?: any = []
  fromdata: any = {}
  async getData(f: any) {
    this.fromdata = f;
    // console.log('form ' ,f)
    this.car_code = f.carcode
    this.getOilData = []
    await this.brdsql.getOilpayed(f).subscribe({
      next: (res: any) => {
        let data = res[0];
        console.log('ข้อมูลการเบิกน้ำมันงวด ', data)
        this.getOilData = data
        this.oillimit[0] = data.oil_left;
        this.oillimit[1] = data.OIL_LITRE;
        this.oilPeriod_cane = data.period_cane
        this.getDataoilList(f)
      }
    })
  }

  // รายละเอียดข้อมูลการเบิกน้ำมัน
  getOilDataList?: any = []
  async getDataoilList(f: any) {
    this.spinner.show();
    this.getOilDataList = [];
    console.log('getDataoilList:', f)
    await this.brdsql.getOilpayedList(f).subscribe({
      next: (res: any) => {
        this.getOilDataList = res
        // console.log('getOilDataList' ,this.getOilDataList)
        this.spinner.hide();
      }
    })
  }

  hurl = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/'

  // รายการเบิกน้ำมันที่เลือก เพื่อใช้พิมพ์ใบเบิก
  docSelectData: any[] = []
  async docSelect(data, action: number) {
    this.docSelectData = []
    let data2: any
    let type_doc = data.oil_type == '1' ? 'v_oilpay_carcut' : 'v_oilpay_carkeep';

    let url = `${this.hurl}dbcps/select_s_f_w_0?s=*&f=dbo.[${type_doc}]&w=dataid=${data.dataid}`;
    await axios.get(url)
      .then(res => {
        let data = (res.data)
        data2 = data[0];
      }).catch(err => { console.log(err); })

    //$("#payoilPrint").modal('show');
    const cnt_print: number = data2.cnt_print > 0 ? data2.cnt_print : 0;
    if (action == 1) {
      let remark_print_2 = '';
      if (cnt_print > 0) {
        const { value } = await Swal.fire({
          title: `ระบุหมายเหตุ การปริ้นซ้ำ ${cnt_print + 1},\n docid:[${data2.docid}]`,
          input: 'text',
          showCancelButton: true,
          inputValue: data2.remark_print,
          confirmButtonText: 'บันทึก',
          cancelButtonText: 'ยกเลิก',
          inputValidator: (value) => {
            if (!value) { return 'กรุณา ระบุหมายเหตุ!'; }
            return null; // valid
          }
        });
        remark_print_2 = value;
      }
      let ck: boolean;
      if (cnt_print > 0 && !remark_print_2) ck = false;
      else ck = true;
      if (ck && confirm(`ต้องการพิมพ์ใบเบิกน้ำมัน ${data2.docid} หรือไม่?`)) {
        this.docSelectData = [data2];
        let url = `${this.hurl}dbcps/update_t_s_w?t=[dbo].[oilpay]&s=[cnt_print]=${cnt_print + 1},[remark_print]=' ${remark_print_2}'&w=[dataid]=${data.dataid}`;
        await axios.get(url).then(async res => {
          console.log('res cancel ', res)
          this.getDataoilList(this.fromdata)
        }).catch(err => { throw (err) })
        data2.remark_print = remark_print_2;
        setTimeout(() => {
          window.print()
        }, 1000);
      }
      else return;
    }
    else if (action == 2 && cnt_print == 0) {
      if (confirm(`ต้องการยกเลิกใบเบิกน้ำมัน ${data2.docid} หรือไม่?`)) {
        let url = `${this.hurl}dbcps/update_t_s_w?t=[dbo].[oilpay]&s=[doc_status]=0&w=[dataid]=${data.dataid}`;
        await axios.get(url).then(async res => {
          console.log('res cancel ', res)
          this.getDataoilList(this.fromdata)
        }).catch(err => { throw (err) })
      }
      else return;
    }
    else {
      this.getDataoilList(this.fromdata);
      alert('ไม่สามารถยกเลิกได้ เนื่องจากใบเบิกนี้ถูกพิมพ์แล้ว')
      return
    }
  }

  max_ck = 0;
  ckOverpay(f: any) {
    let oil_left = this.oillimit
    let x = f.oil_amount
    let y = (<HTMLInputElement>document.getElementById("oil_amount"))
    let max_ck = 0;
    if (f.period_cane == '00') max_ck = oil_left[0]
    else if (oil_left[1] >= oil_left[0]) max_ck = oil_left[0]
    else if (oil_left[0] >= oil_left[1]) max_ck = oil_left[1]
    if ((x > oil_left[0] || x > oil_left[1]) && f.period_cane != '00') {
      alert('!!เบิกน้ำมันสูงสุดได้แค่ ' + max_ck + ' ลิตรเท่านั้น');
      y.value = max_ck.toString()//oil_left[0].toString()
      f.oil_amount = max_ck//oil_left[0]
    }
    this.max_ck = max_ck;
  }

  async save_payoil(f: any) {
    this.ckOverpay(f);
    console.log('save_payoil:', this.max_ck, f.oil_amount, f);
    if (f.oil_amount == 0) {
      alert('จำนวนเบิกต้องมากกว่า 0')
    }
    else if (f.oil_amount > this.max_ck) {
      alert('!!เบิกน้ำมันสูงสุดได้แค่' + this.max_ck)
    }
    else {
      if (confirm(`ต้องการบันทึกข้อมูล ขอเบิกน้ำมัน ${f.carcode}  จำนวน ${f.oil_amount} ลิตร \n หมายเหตุ ${f.remark} หรือไม่?`)) {
        await this.brdsql.saveAddOilPay(f).subscribe({
          next: (res: any) => {
            // console.log('res save ' ,res)
            //this.getDataoilList(f)
            this.getData(f);
          }
        })
      }
    }
  }

  // modalPrintDoc(dataid:any) {
  //   this.cpbyone = [];
  //   $("#payoilPrint").modal('show');
  //   this.cpbyone = this.auditdata.filter((el: { DataId: any; }) => el.DataId == dataid);
  //   console.log('cpbyone: ',this.cpbyone);
  // };

  printDoc() {
    const printContent: any = document.getElementById("oilpayPrint");
    const WindowPrt: any = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }

  print() {
    window.print()
  }

  closemodel() {
    $("#payoilPrint").modal('hide');
  }

  ngOnDestroy() {
    // คืน Memory
    if (this.sub_groupdata) {
      this.sub_groupdata.unsubscribe()
    }
  }

}
